<template>
  <div
    class="animation-container"
    :class="{ horizontal, paused, 'horizontal-reverse': horizontalReverse }"
    :style="`--duration-h: ${durationH || '120s'}; --duration-v: ${durationV || '20s'};`"
    @click="paused = !paused"
  >
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    horizontal: { type: Boolean },
    horizontalReverse: { type: Boolean },
    durationH: { type: String, default: '120s' },
    durationV: { type: String, default: '20s' },
  },
  data() {
    return {
      paused: false,
    };
  },
};
</script>

<style lang="scss">
.animation-container {
  animation: vertical-sliding var(--duration-v) linear infinite;

  &.horizontal {
    animation: horizontal-sliding var(--duration-h) linear infinite;
  }

  &.horizontal-reverse {
    animation: horizontal-reverse-sliding var(--duration-h) linear infinite;
  }

  &:hover {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
}

@keyframes vertical-sliding {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

@keyframes horizontal-sliding {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes horizontal-reverse-sliding {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

@include bp($bp-mobile) {
  .animation-container {
    &:hover {
      -webkit-animation-play-state: running;
      animation-play-state: running;
    }

    &.paused {
      -webkit-animation-play-state: paused;
      animation-play-state: paused;
    }
  }
}
</style>
